export default __webpack_public_path__ + "static/media/AGC_Question_Paper_Class_2.ba27c60e.pdf";